<header class="dashboard-header">
  <div class="logo-section">
    <mat-icon>science</mat-icon>
    <div class="logo-text">

      <span class="lab-name">
        {{ labName }}
      </span>

      <span class="lab-type">
        Lab
      </span>

    </div>
  </div>

  <div class="actions">
    <button mat-button color="warn" (click)="onLogout()">

      <mat-icon>logout</mat-icon>
      Logout

    </button>
  </div>
</header>